"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCookbookMutationOptions = exports.createCookbookMutation = void 0;
const client_1 = require("@apollo/client");
const apolloComponents_1 = require("../../../generated/apolloComponents");
const updateQuery_1 = require("../../../utils/updateQuery");
const cookbook_1 = require("../fragments/cookbook");
const browseCookbook_1 = require("../queries/browseCookbook");
exports.createCookbookMutation = client_1.gql `
  mutation CreateCookbook($input: CookbookInput!) {
    createCookbook(input: $input) {
      __typename
      errors {
        path
        message
      }
      cookbook {
        ...justCookbook
      }
    }
  }

  ${cookbook_1.justCookbookFragment}
`;
exports.createCookbookMutationOptions = (variables, byName) => ({
    variables,
    update: (store, { data: dataResponse }) => {
        if (!dataResponse) {
            return;
        }
        const { createCookbook } = dataResponse;
        if (createCookbook.cookbook) {
            updateQuery_1.updateQuery(store, browseCookbook_1.cookbooksQuery, x => {
                x.cookbooks.unshift(Object.assign(Object.assign({}, createCookbook.cookbook), { byName, accessLevel: apolloComponents_1.CookbookAccessLevel.Owner }));
            });
        }
    },
});
//# sourceMappingURL=createCookbook.js.map